<script setup lang="ts">
import {computed} from 'vue'
import {storeToRefs} from 'pinia'
import {useRoute, useRouter} from 'vue-router'
import {Home} from 'lucide-vue-next'
import {useUserStore} from '@/stores/user'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from '@/components/ui/sidebar'
import CardsNav from './CardsNav.vue'
import ControlPanelNav from './ControlPanelNav.vue'
import UserMenu from './UserMenu.vue'
const props = defineProps<{showLearningNav: boolean; open?: boolean}>()
const emit = defineEmits<{settings: []; close: []}>()
const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const {setOpenMobile} = useSidebar()
const {user, profile} = storeToRefs(userStore)
const isAdmin = computed(() => user.value !== null && ['manager', 'admin'].includes(user.value.role))
function goHome() {
  router.push('/')
  closeMobile()
}
function closeMobile() {
  setOpenMobile(false)
  emit('close')
}
function openSettings() {
  closeMobile()
  emit('settings')
}
</script>
<template>
  <Sidebar collapsible="icon" class="border-sidebar-border">
    <SidebarHeader class="gap-2 p-2">
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            :is-active="route.path === '/'"
            :tooltip="$t('common.home')"
            class="w-full"
            @click="goHome">
            <Home class="size-4" />
            <span>{{ $t('common.home') }}</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarHeader>
    <SidebarContent class="scrollbar-laconic">
      <CardsNav v-if="user && profile && props.showLearningNav" @close="closeMobile" />
      <ControlPanelNav v-if="!props.showLearningNav && isAdmin" @close="closeMobile" />
    </SidebarContent>
    <SidebarFooter>
      <UserMenu
        v-if="user"
        :email="user.email"
        :is-admin="['manager', 'admin'].includes(user.role)"
        @settings="openSettings"
        @close="closeMobile" />
    </SidebarFooter>
    <SidebarRail />
  </Sidebar>
</template>
